import { Avatar, Button, Input, message, Popconfirm, Select, Table, Tag, Tooltip,Modal } from 'antd'
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { SERVER_ADDRESS } from '../../Config/Config';
import { EyeFilled, SearchOutlined, SyncOutlined, UserOutlined } from '@ant-design/icons';
import { PiRecycleDuotone } from "react-icons/pi";


const SuspendedList = () => {
    const [loading,setLoading] = useState(true)
    const [users,setUsers] = useState([]);
    const [filteredUser,setFilteredUser] = useState([]);
    const [searchTerm,setSearchTerm] = useState('');
    const [gender,setGender] = useState(null)
    const [suspendModal,setSuspendModal] = useState(false);
    const [suspendReason,setSuspendReason] = useState('')

    const handleSuspendClose = ()=>{
        setSuspendModal(false)
    }
    
    const fetchSuspendedAccouts = async()=>{
        try {
            const response = await axios.get(`${SERVER_ADDRESS}/api/suspendedAccounts`);
            setUsers(response.data.data)
            setFilteredUser(response.data.data)
            setLoading(false)
        } catch (error) {
            console.log(error)
            message.error({content:"Oops Something Went Wrong !"})
            setLoading(false)
        }
    }

    useEffect(()=>{
        fetchSuspendedAccouts();
    },[])

    const handleDisSuspend = async(id)=>{
        const response = await axios.post(`${SERVER_ADDRESS}/api/suspendAccount`,{
            id,suspend_reason:"",type:2   
        })
        if(response.status === 200){
            const updatedUsers = users.filter(user=>user.id !== id)
            setFilteredUser(updatedUsers);
            message.success({content:"Account unbanned"})
        }
    }

    const columns = [
        {
            title:"id",
            dataIndex:"id",
            key:"id",
            sorter:(a,b)=>a.id - b.id
        },
        {
            title:"Profile",
            dataIndex:"photo",
            key:"photo",
            render:(_,record)=>{
                return record.photo ? (
                    <Avatar src={record.photo[0]} size={64} />
                ) : (
                    <UserOutlined />
                )
            }
        },
        {
            title:"Name",
            dataIndex:"name",
            key:"name",
            render:(_,record)=>{
                const text = record.name
                const dispText = text.length > 10 ? `${text.slice(0,10)}...` : text;
                return text.length > 10 ? (
                    <Tooltip title={text} placement='top' >
                        {dispText}
                    </Tooltip>
                ) : (
                    <span>{text}</span>
                )
            },
            sorter:(a,b)=>a.name.localeCompare(b.name)
        },
        {
            title:"Gender",
            dataIndex:"gender",
            key:"gender",
            render:(_,record)=>{
                return record.gender === '1' ? (<Tag color='blue'>Groom</Tag>) : (<Tag color='magenta' >Bride</Tag>) }
        },
        {
            title:"Email",
            dataIndex:"email",
            key:"email"
        },
        {
            title:"Phone",
            dataIndex:"phone",
            key:"phone"
        },
        {
            title:"Account Status",
            dataIndex:"is_verified",
            key:"is_verified",
            render:(_,record)=>{
                if(record.is_verified === 0){
                    return (
                        <Tag color='red' >Not Verifed</Tag>
                    )
                }
                else if(record.is_verified === 1){
                    return (
                        <Tag color='blue' icon={<SyncOutlined spin />} >Under Verification</Tag>
                    )
                }
                else{
                    return (
                        <Tag color='green' >Verified</Tag>
                    )
                }
            }
        },
        {
            title:"Option",
            key:"option",
            render:(_,record)=>(
                <>
                <div className='' style={{display:'flex',flexDirection:"row",gap:"0.5rem"}} >
                <Tooltip title='View Suspend Details' >
                    <Button onClick={()=>{setSuspendModal(true);setSuspendReason(record.suspend_reason)}} variant='filled' color='blue'><EyeFilled /> </Button>
                </Tooltip>
                <Tooltip title='Unban this account' >
                    <Popconfirm title='Are You Sure want to recover this account ?' onConfirm={()=>{handleDisSuspend(record.id)}} >
                    <Button variant='solid' color='cyan' ><PiRecycleDuotone /></Button>
                    </Popconfirm>
                </Tooltip>
                </div>
                </>
            )
        }
    ]

    useEffect(()=>{
        applyFilter();
    },[searchTerm,gender])

    const applyFilter = ()=>{
        let filtered = users;
        if(!searchTerm){
            setFilteredUser(users)
        }
        else if(searchTerm) {
            filtered = filtered.filter((user)=>{
                user.name.toLowerCase().includes(searchTerm.toLowerCase())
            })
        }
        if (gender !== null) {
            filtered = filtered.filter((user) => user.gender == gender);
        }
        setFilteredUser(filtered)
    }

    const genderOption =[
        {
            label:"Groom",
            value:'1'
        },
        {
            label:"Bride",
            value:"2"
        }
    ]

  return (
    <>
    <div className="d-flex flex-row justify-content-between" style={{marginTop:"4rem",marginBottom:"2rem"}}>
        <h3>Suspended Users</h3>
    </div>
     <div className='d-flex flex-row gap-4 mb-3' >
        <Input style={{width:'14rem'}} onChange={(e)=>setSearchTerm(e.target.value)} placeholder='Search By Name' prefix={<SearchOutlined />} />
        <Select style={{width:'14rem'}} onChange={(e)=>setGender(e)} options={genderOption} placeholder='Select by Gender' />
    </div>
    <div className='d-flex flex-col' style={{marginTop:'2rem'}} >
        <Table rowKey="id" columns={columns} dataSource={filteredUser} loading={loading} style={{width:"100%"}} />
    </div>
    <Modal title='Suspend Reason' onCancel={handleSuspendClose} open={suspendModal} footer={false} >
        <p style={{fontFamily:'sans-serif',fontSize:"1rem"}}>{suspendReason ? suspendReason : "No reason for suspend"}</p>
    </Modal>
    </>
  )
}

export default SuspendedList